module.exports = __webpack_public_path__ + "img/attention.abfb87dc.svg";